import { useSession } from "next-auth/react";
import toast from "react-hot-toast";
import * as analytics from "utils/analytics";
import { postData } from "utils/helpers";
import { getStripePlans } from "utils/stripeCreds";

const stripePlans = getStripePlans();

export function useSubscription() {
  const { data: session } = useSession() ?? {};

  const updatePlan = async (
    plan: string,
    discount = "",
    callback = () => {}
  ) => {
    if (!session?.user?.data?.subscription?.subscription) {
      
      toast.error("subscription to update not found, please contact us");
      return;
    }

    let data = {
      isLocal: !process.env.NODE_ENV || process.env.NODE_ENV === "development",
      newPrice: stripePlans[plan],
      subscription: session.user.data.subscription.subscription,
      idUser: session.user.uid,
      discount,
    };

    let stripeUpdate = await postData({
      url: "payment-updateSubscription",
      token: "",
      data: data,
    });

    if (stripeUpdate.success) {
      toast.success("Subscription updated successfully");
      
      // @ts-ignore
      session.user.data.subscription.price = stripePlans[plan];
      callback && callback();
      return true;
    } else {
      toast.error("Failed to update subscription please contact us");
      return false;
    }
  };

  return { updatePlan };
}
